import React from "react";
import logo from "../../assets/logoWithName.svg";
import { Bars3Icon } from "@heroicons/react/24/outline";
import classes from "./header.module.css";

export const Header = ({ onMenuClick }) => {
  return (
    <div className={classes.container}>
      <div className={classes.container__box}>
        
        {/* Menu Button */}
        <button
          className={classes.menuBtn}
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <Bars3Icon className={classes.menuIcon} />
        </button>

        {/* Logo */}
        <div className={classes.container__box__logo}>
          <img src={logo} alt="Logo" className={classes.container__box__img} />
        </div>

      </div>
    </div>
  );
};
